<template>
  <v-btn
    :disabled="disableButton"
    color="success"
    dark
    :loading="loading"
    @click.stop="emitClick"
    round
  >
    <v-icon left>mdi-printer</v-icon>
    {{ $t('print-barcode-component.print-button-label') }}
  </v-btn>
</template>

<script>
import { BrowserPrint } from "../../utils/BrowserPrint.js";
import i18n from "../../i18n";

export default {
  props: {
    disableButton: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      loading: false,
      selectedPrinter: null,
      defaultMode: true,
      availablePrinters: null,
      zpl: `^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR5,5~SD15^JUS^LRN^CI0^XZ
                ^XA
                ^MMT
                ^PW799
                ^LL0400
                ^LS0
                ^BY2,3,102^FT30,121^BCN,,Y,N
                ^FD#BARCODE#^FS
                ^FT575,77^A0N,25,24^FH\^FDC.M:^FS
                ^FT610,78^A0N,28,25^FB150,1,0,R^FH\^FD#SCALEFEE#^FS
                ^FT570,116^A0N,25,24^FH\^FDFlete: ^FS
                ^FT630,115^A0N,28,28^FB150,1,0,R^FH\^FD#SHIPPINGFEE#^FS
                ^FT570,150^A0N,25,24^FH\^FDCant: ^FS
                ^FT630,150^A0N,28,28^FB37,1,0,R^FH\^FD#CONSECUTIVE#^FS
                ^FT35,176^A0N,25,24^FH\^FDNombre Paciente:^FS
                ^FT223,177^A0N,25,24^FH\^FD#PATIENT_NAME#^FS
                ^FT36,211^A0N,25,26^FH\^FDCiudad:^FS
                ^FT130,211^A0N,25,24^FH\^FD#CITY#^FS
                ^FT35,245^A0N,25,24^FH\^FDDireccion:^FS
                ^FT140,245^A0N,25,24^FH\^FD#ADDRESS#^FS
                ^FTFT400,211^A0N,25,24^FH\^FDFranja horaria:^FS
                ^FT550,211^A0N,25,24^FH\^FD#SCHEDULE_RANGE#^FS
                ^FT32,285^A0N,25,24^FH\^FDTelefono Contacto:^FS
                ^FT224,288^A0N,25,24^FH\^FD#CELLPHONE#^FS
                ^FT430,288^A0N,25,24^FH\^FD#PHONE#^FS
                ^FT33,321^A0N,23,24^FH\^FDObservacion:^FS
                ^FT33,361^A0N,25,24^FH\^FD#OBSERVATION#^FS
                ^PQ1,0,1,Y^XZ`
    };
  },
  mounted() {
    this.configuratePrinter();
  },

  methods: {
    configuratePrinter() {
      BrowserPrint.getDefaultDevice(
        "printer",
        printer => {
          if (printer != null && printer.connection != undefined) {
            this.selectedPrinter = printer;
          }

          BrowserPrint.getLocalDevices(
            printers => {
              this.availablePrinters = printers;
              let thereArePrintersAvailable = false;

              if (printers != undefined) {
                for (let i = 0; i < printers.length; i++) {
                  if (printers[i].connection == "usb") {
                    thereArePrintersAvailable = true;
                  }
                }
              }

              if (!thereArePrintersAvailable) {
                this.printNoPrintersAvailable();
                return;
              } else if (this.selectedPrinter === null) {
                this.defaultMode = false;
                this.changePrinter();
              }
            },
            undefined,
            "printer"
          );
        },
        function(error_response) {
          this.printNoPrintersAvailable();
        }
      );
    },

    changePrinter() {
      this.defaultMode = false;
      this.selectedPrinter = null;

      if (this.availablePrinters == null) {
        this.$notify({
          group: "app",
          type: "info",
          text: i18n.t("print-barcode-component.finding-printers")
        });

        setTimeout(changePrinter, 200);
        return;
      }

      this.selectedPrinter = this.availablePrinters[0];
    },

    emitClick() {
      this.$emit("buttonClick");
    },

    sendDataToPrinter(stickerData, barcode) {
      if (!stickerData || stickerData == "") return;
      if (!barcode || barcode == "") return;

      if (!this.selectedPrinter) {
        this.configuratePrinter();
        this.printNoPrintersAvailable();
        return;
      }

      const finishedFunction = text => {
        if (text == "Ready to Print") {
          this.$notify({
            group: "app",
            type: "info",
            text: i18n.t("print-barcode-component.printing-in-process")
          });

          this.selectedPrinter.send(
            this.zpl
              .replace("#PATIENT_NAME#", stickerData.patientName)
              .replace("#ADDRESS#", stickerData.address)
              .replace("#CITY#", stickerData.city)
              .replace("#SCHEDULE_RANGE#", stickerData.scheduleRange)
              .replace("#CELLPHONE#", stickerData.cellphone)
              .replace("#PHONE#", stickerData.phone)
              .replace("#SCALEFEE#", stickerData.scaleFee)
              .replace("#SHIPPINGFEE#", stickerData.shippingFee)
              .replace("#CONSECUTIVE#", stickerData.consecutive)
              .replace("#OBSERVATION#", stickerData.observation)
              .split("#BARCODE#")
              .join(barcode)
          );

          this.$emit("print");
        } else {
          this.printError(text);
        }
      };

      this.checkPrinterStatus(finishedFunction);
    },

    checkPrinterStatus(finishedFunction) {
      this.selectedPrinter.sendThenRead(
        "~HQES",
        function(text) {
          var that = this;
          var statuses = new Array();
          var ok = false;
          var is_error = text.charAt(70);
          var media = text.charAt(88);
          var head = text.charAt(87);
          var pause = text.charAt(84);
          // check each flag that prevents printing
          if (is_error == "0") {
            ok = true;
            statuses.push("Ready to Print");
          }
          if (media == "1") statuses.push("Paper out");
          if (media == "2") statuses.push("Ribbon Out");
          if (media == "4") statuses.push("Media Door Open");
          if (media == "8") statuses.push("Cutter Fault");
          if (head == "1") statuses.push("Printhead Overheating");
          if (head == "2") statuses.push("Motor Overheating");
          if (head == "4") statuses.push("Printhead Fault");
          if (head == "8") statuses.push("Incorrect Printhead");
          if (pause == "1") statuses.push("Printer Paused");
          if (!ok && statuses.Count == 0) statuses.push("Error: Unknown Error");
          finishedFunction(statuses.join());
        },
        () => {
          this.printerError(i18n.t("print-barcode-component.printing-error"));
        }
      );
    },

    printNoPrintersAvailable() {
      this.printError(i18n.t("print-barcode-component.no-printers-available"));
    },

    printError(text) {
      this.$notify({
        group: "app",
        type: "error",
        text: i18n.t(text)
      });
    }
  }
};
</script>
